import React from "react";
import {getOptionName, toArray} from "../../utils/selectbox/selectorUtils";
import {ChevronDownIcon, ChevronRightIcon} from "./SelectorIcons";
import SelectorOptionLabel from "./SelectorOptionLabel";

function SelectorTreeList({
    list,
    depth = 0,
    expandedMenus,
    onToggleExpand,
    selected,
    onSelect,
    recursive,
    /** id가 없을 때 name으로 active 매칭(엑셀 등 특수 케이스) */
    matchActiveByNameWhenIdMissing = false,
}) {
    if (!list?.length) return null;

    return (
        <>
            {list.map((item) => {
                const children = toArray(item.children);
                const hasChildren = recursive && children.length > 0;
                const isExpanded = !!expandedMenus[item.id];
                const selectedById = String(selected?.id) === String(item.id);
                const selectedByName =
                    matchActiveByNameWhenIdMissing
                    && (selected?.id == null)
                    && String(getOptionName(selected) ?? "").trim() !== ""
                    && String(getOptionName(selected) ?? "").trim()
                        === String(getOptionName(item) ?? "").trim();
                const isSelected = selectedById || selectedByName;

                return (
                    <React.Fragment key={item.id}>
                        <div
                            className={`selector-tree-row ${isSelected ? "is-selected" : ""}`}
                            style={{paddingLeft: `${depth * 16 + 4}px`}}
                        >
                            {recursive && (
                                hasChildren ? (
                                    <button
                                        type="button"
                                        className="selector-tree-toggle"
                                        title={isExpanded ? "접기" : "펼치기"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onToggleExpand(item.id);
                                        }}
                                    >
                                        {isExpanded ? (
                                            <ChevronDownIcon style={{width: "12px", height: "12px"}}/>
                                        ) : (
                                            <ChevronRightIcon style={{width: "12px", height: "12px"}}/>
                                        )}
                                    </button>
                                ) : (
                                    <span className="selector-tree-toggle-spacer" aria-hidden="true"/>
                                )
                            )}

                            <div className="selector-tree-select" onClick={() => onSelect(item)}>
                                <SelectorOptionLabel option={item} />
                            </div>
                        </div>

                        {recursive && hasChildren && isExpanded && (
                            <SelectorTreeList
                                list={children}
                                depth={depth + 1}
                                expandedMenus={expandedMenus}
                                onToggleExpand={onToggleExpand}
                                selected={selected}
                                onSelect={onSelect}
                                recursive={recursive}
                                matchActiveByNameWhenIdMissing={matchActiveByNameWhenIdMissing}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </>
    );
}

export default SelectorTreeList;
